export function leaderboardDpsFormat(dps: number): string {
  if (dps < 1_000) {
    return dps.toString();
  }

  if (dps < 1_000_000) {
    return `${(dps / 1_000).toFixed(0)}K`;
  }

  if (dps < 1_000_000_000) {
    return `${(dps / 1_000_000).toFixed(0)}M`;
  }

  return `${(dps / 1_000_000_000).toFixed(0)}B`;
}
